/* ALTON — global behavior: veil transitions, reveal, header, mega menu, search,
   drawers, popup, cursor, magnetic buttons, smooth scroll. */
(function () {
  'use strict';

  var settings = window.altonSettings || {};
  var routes = window.altonRoutes || {};
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* ---------- Focus trap helper ---------- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function trapFocus(container) {
    function handler(e) {
      if (e.key !== 'Tab') return;
      var els = Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
      if (!els.length) return;
      var first = els[0];
      var last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }

  /* ---------- Overlay manager (mega menu, cart drawer, search, popup, lightbox) ---------- */
  var openOverlay = null;

  window.altonOverlay = {
    open: function (el, opts) {
      opts = opts || {};
      if (openOverlay && openOverlay.el !== el) this.close();
      el.classList.add('open');
      var scrim = opts.scrim ? document.querySelector(opts.scrim) : null;
      if (scrim) scrim.classList.add('on');
      if (opts.lockScroll) document.body.style.overflow = 'hidden';
      var release = trapFocus(el);
      var returnFocus = document.activeElement;
      var focusTarget = el.querySelector('[data-autofocus]') || el.querySelector(FOCUSABLE);
      if (focusTarget) focusTarget.focus({ preventScroll: true });
      openOverlay = { el: el, scrim: scrim, release: release, returnFocus: returnFocus, opts: opts };
      var trigger = opts.trigger;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    },
    close: function () {
      if (!openOverlay) return;
      var o = openOverlay;
      openOverlay = null;
      o.el.classList.remove('open');
      if (o.scrim) o.scrim.classList.remove('on');
      document.body.style.overflow = '';
      o.release();
      if (o.opts.trigger) o.opts.trigger.setAttribute('aria-expanded', 'false');
      if (o.returnFocus && o.returnFocus.focus) o.returnFocus.focus({ preventScroll: true });
    },
    current: function () { return openOverlay ? openOverlay.el : null; }
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.altonOverlay.close();
  });

  /* ---------- Veil page transitions ---------- */
  var veil = document.getElementById('veil');
  if (veil && !reducedMotion && !designMode) {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.closest('.drawer')) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
      if (url.pathname.indexOf('/cart') === 0 && a.hasAttribute('data-cart-open')) return;
      e.preventDefault();
      veil.classList.add('on');
      setTimeout(function () { location.href = a.href; }, 280);
    });
    window.addEventListener('pageshow', function () { veil.classList.remove('on'); });
  }

  /* ---------- Reveal on scroll ---------- */
  if (!settings.reveal || reducedMotion || !('IntersectionObserver' in window)) {
    document.documentElement.classList.add('no-reveal');
  } else {
    var revealed = function (el) { el.classList.add('in'); obs.unobserve(el); };
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) revealed(en.target); });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    var watch = function (root) {
      (root || document).querySelectorAll('.aos:not(.in)').forEach(function (el) { obs.observe(el); });
    };
    watch();
    setTimeout(function () {
      document.querySelectorAll('.aos:not(.in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('in');
      });
    }, 1500);
    document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
  }

  /* ---------- Header scroll state ---------- */
  var hdr = document.querySelector('.hdr');
  var isHome = document.body.classList.contains('template-index');
  function onScroll() {
    if (hdr && isHome) hdr.classList.toggle('solid', window.scrollY > 60);
    var heroSlides = document.querySelector('[data-hero-parallax]');
    if (heroSlides && !reducedMotion) {
      var hero = heroSlides.closest('.hero');
      var p = Math.min(1, window.scrollY / hero.offsetHeight);
      heroSlides.style.transform = 'translateY(' + (p * 8) + '%) scale(' + (1 + p * 0.04) + ')';
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Mega menu ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest ? e.target.closest('[data-mega-toggle]') : null;
    if (toggle) {
      e.preventDefault();
      var mega = document.getElementById('MegaMenu');
      if (!mega) return;
      if (mega.classList.contains('open')) window.altonOverlay.close();
      else window.altonOverlay.open(mega, { trigger: toggle });
      return;
    }
    var searchToggle = e.target.closest ? e.target.closest('[data-search-toggle]') : null;
    if (searchToggle) {
      e.preventDefault();
      var bar = document.getElementById('SearchBar');
      if (!bar) return;
      if (bar.classList.contains('open')) window.altonOverlay.close();
      else window.altonOverlay.open(bar, { trigger: searchToggle });
      return;
    }
    var mega2 = document.getElementById('MegaMenu');
    if (mega2 && mega2.classList.contains('open') && !mega2.contains(e.target) && !e.target.closest('.hdr')) {
      window.altonOverlay.close();
    }
  });

  /* ---------- Predictive search ---------- */
  var searchInput = document.querySelector('#SearchBar input[type="search"]');
  var searchResults = document.getElementById('PredictiveResults');
  var searchTimer = null;
  if (searchInput && searchResults && routes.predictiveSearch) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch(routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[limit]=6&resources[type]=product&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('#PredictiveInner');
            searchResults.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------- Cart drawer open/close ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest ? e.target.closest('[data-cart-open]') : null;
    if (openBtn) {
      var drawer = document.getElementById('CartDrawer');
      if (drawer) {
        e.preventDefault();
        window.altonOverlay.open(drawer, { scrim: '#CartScrim', lockScroll: true, trigger: openBtn });
      }
      return;
    }
    if (e.target.closest && (e.target.closest('[data-cart-close]') || e.target.id === 'CartScrim')) {
      e.preventDefault();
      window.altonOverlay.close();
    }
  });

  /* ---------- Newsletter popup ---------- */
  var popup = document.getElementById('NewsletterPopup');
  if (popup) {
    var KEY = 'alton:popup-dismissed';
    var dismissedAt = 0;
    try { dismissedAt = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (err) {}
    var daysSince = (Date.now() - dismissedAt) / 864e5;
    var frequency = parseInt(popup.dataset.frequency || '30', 10);
    var showPopup = function () { window.altonOverlay.open(popup, { lockScroll: false }); };
    var hidePopup = function () {
      try { localStorage.setItem(KEY, String(Date.now())); } catch (err) {}
      window.altonOverlay.close();
    };
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]') || e.target === popup) { e.preventDefault(); hidePopup(); }
    });
    if (designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(popup)) showPopup(); else window.altonOverlay.close();
      });
    } else if (daysSince > frequency && popup.dataset.enabled === 'true') {
      setTimeout(showPopup, parseInt(popup.dataset.delay || '5', 10) * 1000);
    }
  }

  /* ---------- Custom cursor ---------- */
  var cursor = document.getElementById('cursor');
  var finePointer = window.matchMedia('(pointer: fine)').matches;
  if (cursor && settings.cursor && finePointer && !reducedMotion) {
    window.addEventListener('mousemove', function (e) {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
      var overCard = e.target.closest ? e.target.closest('.pcard, [data-lightbox-open]') : null;
      var active = overCard && window.innerWidth >= 760;
      cursor.classList.toggle('on', !!active);
      if (active) cursor.textContent = e.target.closest('[data-lightbox-open]') ? (cursor.dataset.zoom || 'Zoom') : (cursor.dataset.view || 'View');
    }, { passive: true });
  }

  /* ---------- Magnetic buttons ---------- */
  if (settings.magnetic && finePointer && !reducedMotion) {
    window.addEventListener('mousemove', function (e) {
      if (window.innerWidth < 760) return;
      var mag = e.target.closest ? e.target.closest('[data-magnetic]') : null;
      document.querySelectorAll('[data-magnetic]').forEach(function (el) {
        if (el === mag) {
          var r = el.getBoundingClientRect();
          el.style.transform = 'translate(' + ((e.clientX - (r.left + r.width / 2)) * 0.14) + 'px,' + ((e.clientY - (r.top + r.height / 2)) * 0.18) + 'px)';
        } else if (el.style.transform) {
          el.style.transform = 'translate(0,0)';
        }
      });
    }, { passive: true });
  }

  /* ---------- Smooth inertia scrolling (desktop) ---------- */
  if (settings.smoothScroll && !reducedMotion && !designMode &&
      !('ontouchstart' in window) && !window.matchMedia('(pointer: coarse)').matches) {
    var sc = document.scrollingElement || document.documentElement;
    var targetY = sc.scrollTop, curY = sc.scrollTop, animating = false, raf = null;
    var loop = function () {
      var diff = targetY - curY;
      if (Math.abs(diff) < 0.4) { curY = targetY; sc.scrollTop = curY; animating = false; raf = null; return; }
      curY += diff * 0.085;
      sc.scrollTop = curY;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey) return;
      if (e.target.closest && e.target.closest('.drawer, .mega, .lightbox, .popup, .search-bar, .filter-panel')) return;
      e.preventDefault();
      var unit = e.deltaMode === 1 ? 16 : (e.deltaMode === 2 ? sc.clientHeight : 1);
      targetY = Math.max(0, Math.min(targetY + e.deltaY * unit * 0.9, sc.scrollHeight - sc.clientHeight));
      if (!animating) { animating = true; curY = sc.scrollTop; raf = requestAnimationFrame(loop); }
    }, { passive: false });
    window.addEventListener('scroll', function () {
      if (!animating) { targetY = sc.scrollTop; curY = sc.scrollTop; }
    }, { passive: true });
  }
})();
